<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="w-full p-10">
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else-if="grad_list && grad_list.length > 0" class="mt-5">
            <h1 class="text-lg py-3 font-semibold text-slate-800">
              Grade Book
            </h1>

            <div
              class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm"
            >
              <table class="min-w-full text-sm">
                <thead class="bg-gray-100 text-blues">
                  <tr>
                    <th
                      class="px-6 py-3 border-b border-r font-semibold text-left"
                    >
                      Title
                    </th>
                    <th class="px-6 py-3 border-b font-semibold text-center">
                      Score / Total Score
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr class="border-b hover:bg-gray-50">
                    <td class="px-6 py-3 border-r font-medium">Assignment</td>
                    <td class="px-6 py-3 text-center">
                      {{
                        grad_list[0]?.assignment?.current_mark != null || grad_list[0]?.percentages?.assignment != null
                          ? `${grad_list[0].assignment.current_mark ?? "NA"} / ${
                              grad_list[0]?.percentages?.assignment ?? "?"
                            }`
                          : "NA"
                      }}
                    </td>
                  </tr>

                  <tr class="border-b hover:bg-gray-50">
                    <td class="px-6 py-3 border-r font-medium">Assessment</td>
                    <td class="px-6 py-3 text-center">
                      {{
                        grad_list[0]?.quize?.current_mark != null || grad_list[0]?.percentages?.assessment != null
                          ? `${grad_list[0].quize.current_mark ?? "NA"} / ${
                              grad_list[0]?.percentages?.assessment ?? "?"
                            }`
                          : "NA"
                      }}
                    </td>
                  </tr>
                    <tr class="border-b hover:bg-gray-50">
                    <td class="px-6 py-3 border-r font-medium">During Semester Assessment</td>
                    <td class="px-6 py-3 text-center">
                      {{
                        grad_list[0]?.overallmark != null || grad_list[0]?.percentages?.assessment != null
                          ? `${grad_list[0].overallmark ?? "NA"} / ${
                              grad_list[0]?.percentages?.total ?? "?"
                            }`
                          : "NA"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div
            v-else
            class="flex flex-col items-center justify-center h-52 p-6 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50"
          >
            <svg
              class="w-10 h-10 text-gray-400 mb-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              ></path>
            </svg>
            <span class="text-sm font-medium text-gray-900"
              >No Grade Data Found</span
            >
            <p class="text-xs text-gray-500 mt-1">
              There are no grades recorded for this period yet.
            </p>
          </div>

          <div class="flex flex-col gap-3 mt-4 hidden">
            <div>
              <h2>Notes:</h2>
            </div>
            <div
              class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden"
            >
              <div class="p-3 md:p-5 space-y-4">
                <!-- Explanation Section -->
                <div>
                  <h3
                    class="text-sm md:text-base font-semibold text-slate-900 mb-1"
                  >
                    Assignment Mark Proportional Conversion
                  </h3>
                  <p class="text-xs md:text-sm text-slate-600 leading-relaxed">
                    The student's assignment marks are converted proportionally
                    to the available grade scale. The assignment score is
                    divided by the total assignment maximum marks and multiplied
                    by the grade scale to determine the final grade mark.
                  </p>
                </div>

                <!-- Formula Box -->
                <div
                  class="bg-indigo-50 border-l-4 border-indigo-500 p-3 rounded-r-lg"
                >
                  <span
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 block mb-1"
                  >
                    Grade Calculation Formula
                  </span>

                  <code
                    class="text-xs md:text-sm font-mono font-semibold text-indigo-900 block break-words"
                  >
                    Grade Mark = (Student Assignment Marks ÷ Total Assignment
                    Maximum Marks) × Grade Maximum Scale
                  </code>
                </div>
                <div
                  class="bg-indigo-50 border border-indigo-100 rounded-lg p-3"
                >
                  <h4
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 mb-2"
                  >
                    Total Assignment Maximum Marks Calculation
                  </h4>

                  <div class="space-y-1 text-sm text-indigo-900">
                    <div class="flex justify-between">
                      <span>Number of Assignments</span>
                      <span class="font-semibold">8</span>
                    </div>

                    <div class="flex justify-between">
                      <span>Marks per Assignment</span>
                      <span class="font-semibold">10</span>
                    </div>

                    <div class="border-t border-indigo-200 my-2"></div>

                    <div class="flex justify-between font-semibold">
                      <span>Total Assignment Maximum Marks</span>
                      <span>8 × 10 = 80</span>
                    </div>
                  </div>
                </div>

                <!-- Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Example Inputs -->
                  <div
                    class="bg-slate-50 p-3 rounded-lg border border-slate-100"
                  >
                    <h4
                      class="text-xs font-bold uppercase tracking-wider text-slate-700 mb-3"
                    >
                      Example Values
                    </h4>

                    <ul class="space-y-2 text-sm">
                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Student Assignment Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          68
                        </span>
                      </li>

                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Total Assignment Maximum Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          80
                        </span>
                      </li>

                      <li class="flex justify-between items-center">
                        <span class="text-slate-600">
                          Grade Maximum Scale
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          10
                        </span>
                      </li>
                    </ul>
                  </div>

                  <!-- Calculation -->
                  <div
                    class="bg-emerald-50 p-3 rounded-lg border border-emerald-100 flex flex-col justify-between"
                  >
                    <div>
                      <h4
                        class="text-xs font-bold uppercase tracking-wider text-emerald-700 mb-3"
                      >
                        Calculation Breakdown
                      </h4>

                      <div
                        class="font-mono text-xs md:text-sm text-emerald-800 space-y-1"
                      >
                        <p>Grade Mark = (68 ÷ 80) × 10</p>
                        <p>Grade Mark = 0.85 × 10</p>
                        <p class="font-semibold">Grade Mark = 8.5</p>
                      </div>
                    </div>

                    <div
                      class="mt-3 pt-3 border-t border-emerald-200 flex justify-between items-center"
                    >
                      <span class="text-sm font-medium text-emerald-900">
                        Final Grade Mark
                      </span>

                      <span
                        class="text-lg md:text-2xl font-mono font-bold text-emerald-700"
                      >
                        8.5
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden"
            >
              <div class="p-3 md:p-5 space-y-4">
                <!-- Explanation Section -->
                <div>
                  <h3
                    class="text-sm md:text-base font-semibold text-slate-900 mb-1"
                  >
                    Assessment Mark Proportional Conversion
                  </h3>

                  <p class="text-xs md:text-sm text-slate-600 leading-relaxed">
                    The student's assessment marks are converted proportionally
                    to the available grade scale. The assessment score is
                    divided by the total assessment maximum marks and multiplied
                    by the grade scale to determine the final grade mark.
                  </p>
                </div>

                <!-- Formula Box -->
                <div
                  class="bg-indigo-50 border-l-4 border-indigo-500 p-3 rounded-r-lg"
                >
                  <span
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 block mb-1"
                  >
                    Grade Calculation Formula
                  </span>

                  <code
                    class="text-xs md:text-sm font-mono font-semibold text-indigo-900 block break-words"
                  >
                    Grade Mark = (Student Assessment Marks ÷ Total Assessment
                    Maximum Marks) × Grade Maximum Scale
                  </code>
                </div>

                <!-- Total Assessment Maximum Marks -->
                <div
                  class="bg-indigo-50 border border-indigo-100 rounded-lg p-3"
                >
                  <h4
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 mb-2"
                  >
                    Total Assessment Maximum Marks Calculation
                  </h4>

                  <div class="space-y-1 text-sm text-indigo-900">
                    <div class="flex justify-between">
                      <span>Number of Assessments</span>
                      <span class="font-semibold">5</span>
                    </div>

                    <div class="flex justify-between">
                      <span>Marks per Assessment</span>
                      <span class="font-semibold">20</span>
                    </div>

                    <div class="border-t border-indigo-200 my-2"></div>

                    <div class="flex justify-between font-semibold">
                      <span>Total Assessment Maximum Marks</span>
                      <span>5 × 20 = 100</span>
                    </div>
                  </div>
                </div>

                <!-- Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Example Values -->
                  <div
                    class="bg-slate-50 p-3 rounded-lg border border-slate-100"
                  >
                    <h4
                      class="text-xs font-bold uppercase tracking-wider text-slate-700 mb-3"
                    >
                      Example Values
                    </h4>

                    <ul class="space-y-2 text-sm">
                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Student Assessment Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          85
                        </span>
                      </li>

                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Total Assessment Maximum Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          100
                        </span>
                      </li>

                      <li class="flex justify-between items-center">
                        <span class="text-slate-600">
                          Grade Maximum Scale
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          20
                        </span>
                      </li>
                    </ul>
                  </div>

                  <!-- Calculation -->
                  <div
                    class="bg-emerald-50 p-3 rounded-lg border border-emerald-100 flex flex-col justify-between"
                  >
                    <div>
                      <h4
                        class="text-xs font-bold uppercase tracking-wider text-emerald-700 mb-3"
                      >
                        Calculation Breakdown
                      </h4>

                      <div
                        class="font-mono text-xs md:text-sm text-emerald-800 space-y-1"
                      >
                        <p>Grade Mark = (85 ÷ 100) × 20</p>
                        <p>Grade Mark = 0.85 × 20</p>
                        <p class="font-semibold">Grade Mark = 17</p>
                      </div>
                    </div>

                    <div
                      class="mt-3 pt-3 border-t border-emerald-200 flex justify-between items-center"
                    >
                      <span class="text-sm font-medium text-emerald-900">
                        Final Grade Mark
                      </span>

                      <span
                        class="text-lg md:text-2xl font-mono font-bold text-emerald-700"
                      >
                        17
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import SideBar from "@/components/Student/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      grad_list: [],
      loading: true,
    };
  },
  created() {
    this.gradebook();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    async gradebook() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/user-skill/?Key=${this.userInfo.token_key}&course__id=${this.course_id}&user__id=${this.userInfo.user.id}`,
        );
        if (response.data && response.data.data) {
          this.grad_list = response.data.data;
        } else {
          this.grad_list = [];
        }
      } catch (error) {
        console.error("Error fetching gradebook details:", error);
        this.grad_list = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
